// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lv-1";
export var stateContainer = "_lv-0";